module.exports = __webpack_public_path__ + "img/dialog_warning.4d00e227.svg";